import { render, staticRenderFns } from "./SecretTimeStudy.vue?vue&type=template&id=2b14d02f&scoped=true&"
import script from "./SecretTimeStudy.vue?vue&type=script&lang=js&"
export * from "./SecretTimeStudy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b14d02f",
  null
  
)

export default component.exports